import animation from 'utils/requestAnimationFrame';
const { useEffect, useState } = require('react');

const loadSvg = (svgString) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      reject(img);
    };

    img.crossOrigin = 'anonymous';
    img.src = svgString;
  });

const textSvg =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='93' viewBox='0 0 450 93' fill='none'%3E%3Cpath d='M62.2847 31V28.7954H60.0698V2.26855H62.2847V0.0537109H88.8115V2.26855H91.0161V6.68799H88.8115V8.90283H86.5967V4.4834H64.4893V26.5806H86.5967V17.7417H75.543V13.3223H91.0161V28.7954H88.8115V31H62.2847Z' fill='%230A1E4C'/%3E%3Cpath d='M122.333 26.5806V4.4834H100.225V26.5806H122.333ZM98.0208 31V28.7954H95.8059V2.26855H98.0208V0.0537109H124.548V2.26855H126.752V28.7954H124.548V31H98.0208Z' fill='%230A1E4C'/%3E%3Cpath d='M171.739 15.5269V4.4834H149.631V15.5269H171.739ZM145.212 31V0.0537109H173.953V2.26855H176.158V17.7417H173.953V19.9565H149.631V31H145.212Z' fill='%230A1E4C'/%3E%3Cpath d='M179.84 31V0.0537109H184.26V13.3223H206.367V0.0537109H210.787V31H206.367V17.7417H184.26V31H179.84Z' fill='%230A1E4C'/%3E%3Cpath d='M226.948 31V15.5269H224.743V13.3223H222.529V11.1074H220.314V8.90283H218.109V6.68799H215.894V4.4834H213.69V2.26855H211.475V0.0537109H218.109V2.26855H220.314V4.4834H222.529V6.68799H224.743V8.90283H226.948V11.1074H231.367V8.90283H233.582V6.68799H235.787V4.4834H238.002V2.26855H240.217V0.0537109H246.841V2.26855H244.636V4.4834H242.421V6.68799H240.217V8.90283H238.002V11.1074H235.787V13.3223H233.582V15.5269H231.367V31H226.948Z' fill='%230A1E4C'/%3E%3Cpath d='M250.861 31V28.7954H248.647V2.26855H250.861V0.0537109H277.388V2.26855H279.593V6.68799H277.388V8.90283H275.173V4.4834H253.066V26.5806H275.173V17.7417H264.12V13.3223H279.593V28.7954H277.388V31H250.861Z' fill='%230A1E4C'/%3E%3Cpath d='M284.383 31V0.0537109H288.802V31H284.383Z' fill='%230A1E4C'/%3E%3Cpath d='M305.251 31V4.4834H291.982V0.0537109H322.928V4.4834H309.67V31H305.251Z' fill='%230A1E4C'/%3E%3Cpath d='M344.227 19.9565V17.7417H342.022V13.3223H339.807V11.1074H337.593V6.68799H333.173V11.1074H330.969V13.3223H328.754V17.7417H326.549V19.9565H344.227ZM313.281 31V28.7954H315.495V24.376H317.7V22.1611H319.915V17.7417H322.12V15.5269H324.334V11.1074H326.549V8.90283H328.754V4.4834H330.969V2.26855H333.173V0.0537109H337.593V2.26855H339.807V4.4834H342.022V8.90283H344.227V11.1074H346.442V15.5269H348.646V17.7417H350.861V22.1611H353.076V24.376H355.281V28.7954H357.495V31H350.861V26.5806H348.646V24.376H322.12V26.5806H319.915V31H313.281Z' fill='%230A1E4C'/%3E%3Cpath d='M358.984 31V0.0537109H363.403V26.5806H389.93V31H358.984Z' fill='%230A1E4C'/%3E%3Cpath d='M11.6484 93V88.5806H9.43359V81.9565H7.229V77.5269H5.01416V68.688H2.80957V64.2686H0.594727V62.0537H7.229V66.4834H9.43359V75.3223H11.6484V79.7417H16.0679V75.3223H18.2827V66.4834H20.4873V62.0537H24.9067V66.4834H27.1216V75.3223H29.3364V79.7417H33.7559V75.3223H35.9604V66.4834H38.1753V62.0537H44.8096V64.2686H42.5947V68.688H40.3901V77.5269H38.1753V81.9565H35.9604V88.5806H33.7559V93H29.3364V88.5806H27.1216V81.9565H24.9067V77.5269H20.4873V81.9565H18.2827V88.5806H16.0679V93H11.6484Z' fill='%230A1E4C'/%3E%3Cpath d='M46.4207 93V62.0537H50.8401V93H46.4207Z' fill='%230A1E4C'/%3E%3Cpath d='M67.2886 93V66.4834H54.02V62.0537H84.9663V66.4834H71.708V93H67.2886Z' fill='%230A1E4C'/%3E%3Cpath d='M86.885 93V62.0537H91.3045V75.3223H113.412V62.0537H117.831V93H113.412V79.7417H91.3045V93H86.885Z' fill='%230A1E4C'/%3E%3Cpath d='M149.559 93V66.4834H136.291V62.0537H167.237V66.4834H153.979V93H149.559Z' fill='%230A1E4C'/%3E%3Cpath d='M169.156 93V62.0537H173.575V93H169.156Z' fill='%230A1E4C'/%3E%3Cpath d='M181.759 93V90.7954H179.544V64.2686H181.759V62.0537H208.286V64.2686H210.491V68.688H208.286V70.9028H206.071V66.4834H183.964V88.5806H206.071V84.1611H208.286V86.376H210.491V90.7954H208.286V93H181.759Z' fill='%230A1E4C'/%3E%3Cpath d='M213.64 93V62.0537H218.059V75.3223H226.908V73.1074H229.113V70.9028H231.328V68.688H233.532V66.4834H235.747V64.2686H237.952V62.0537H244.586V64.2686H242.381V66.4834H240.167V68.688H237.952V70.9028H235.747V73.1074H233.532V75.3223H231.328V79.7417H233.532V81.9565H235.747V84.1611H237.952V86.376H240.167V88.5806H242.381V90.7954H244.586V93H237.952V90.7954H235.747V88.5806H233.532V86.376H231.328V84.1611H229.113V81.9565H226.908V79.7417H218.059V93H213.64Z' fill='%230A1E4C'/%3E%3Cpath d='M246.997 93V62.0537H277.943V66.4834H251.416V75.3223H266.889V79.7417H251.416V88.5806H277.943V93H246.997Z' fill='%230A1E4C'/%3E%3Cpath d='M292.72 93V66.4834H279.452V62.0537H310.398V66.4834H297.14V93H292.72Z' fill='%230A1E4C'/%3E%3Cpath d='M312.317 93V62.0537H316.736V64.2686H318.951V66.4834H321.156V68.688H323.37V70.9028H325.585V73.1074H327.79V75.3223H330.005V73.1074H332.209V70.9028H334.424V68.688H336.629V66.4834H338.844V64.2686H341.058V62.0537H345.478V93H341.058V70.9028H338.844V73.1074H336.629V75.3223H334.424V77.5269H332.209V79.7417H330.005V81.9565H327.79V79.7417H325.585V77.5269H323.37V75.3223H321.156V73.1074H318.951V70.9028H316.736V93H312.317Z' fill='%230A1E4C'/%3E%3Cpath d='M351.416 93V62.0537H382.362V66.4834H355.836V75.3223H371.309V79.7417H355.836V88.5806H382.362V93H351.416Z' fill='%230A1E4C'/%3E%3Cpath d='M397.14 93V66.4834H383.871V62.0537H414.817V66.4834H401.559V93H397.14Z' fill='%230A1E4C'/%3E%3Cpath d='M436.116 81.9565V79.7417H433.911V75.3223H431.696V73.1074H429.482V68.688H425.062V73.1074H422.858V75.3223H420.643V79.7417H418.438V81.9565H436.116ZM405.17 93V90.7954H407.384V86.376H409.589V84.1611H411.804V79.7417H414.008V77.5269H416.223V73.1074H418.438V70.9028H420.643V66.4834H422.858V64.2686H425.062V62.0537H429.482V64.2686H431.696V66.4834H433.911V70.9028H436.116V73.1074H438.331V77.5269H440.535V79.7417H442.75V84.1611H444.965V86.376H447.17V90.7954H449.384V93H442.75V88.5806H440.535V86.376H414.008V88.5806H411.804V93H405.17Z' fill='%230A1E4C'/%3E%3C/svg%3E";

const animate = ({ canvasRef, containerRef }) => {
  let isPlaying = false;
  var canvas = canvasRef.current,
    ctx = canvas.getContext('2d', { willReadFrequently: true });
  const container = containerRef.current;
  let containerBounds = container.getBoundingClientRect();
  let canvasBounds = canvas.getBoundingClientRect();

  let cw = 0;
  let ch = 0;

  const pixelRatio = window.devicePixelRatio;
  const radius = 6400 * pixelRatio;
  const drag = 0.92;
  const ease = 0.02 / pixelRatio;
  const density = 1;
  const offset = 1;
  let pixels;
  let particles = [];

  let mx = 0,
    my = 0;

  let canvasLeft = 0,
    canvasTop = 0;

  const calculateSizes = () => {
    containerBounds = container.getBoundingClientRect();
    canvasBounds = canvas.getBoundingClientRect();
    canvasLeft = Math.round(containerBounds.left * pixelRatio);
    canvasTop = Math.round(containerBounds.top * pixelRatio);
    canvas.width = Math.round(containerBounds.right * pixelRatio) - canvasLeft;
    canvas.height = Math.round(containerBounds.bottom * pixelRatio) - canvasTop;
    canvas.style.width = containerBounds.width + 'px';
    canvas.style.height = containerBounds.height + 'px';
    cw = canvas.width;
    ch = canvas.height;
  };

  const getPointerCoords = () => {
    return {
      x: mx - canvasLeft,
      y: my - canvasTop,
    };
  };

  const imagePromise = loadSvg(textSvg);

  var Particle = function (x, y) {
    this.hx = ~~(x - offset * Math.random());
    this.hy = ~~(y - offset * Math.random());
    this.cx = ~~(cw * Math.random());
    this.cy = ~~(ch * Math.random());
    this.vx = Math.random() * 10 - 5;
    this.vy = Math.random() * 10 - 5;
  };

  Particle.prototype.update = function () {
    const pointer = getPointerCoords();
    const dx = this.cx - pointer.x;
    const dy = this.cy - pointer.y;
    const ds = dx * dx + dy * dy;
    const aradius = Math.min(radius / ds, radius);
    const theta = Math.atan2(dy, dx);

    const hdx = this.hx - this.cx;
    const hdy = this.hy - this.cy;
    const hds = Math.sqrt(hdx * hdx + hdy * hdy);
    const hf = hds * 0.01;
    const htheta = Math.atan2(hdy, hdx);

    this.vx += aradius * Math.cos(theta) + hf * Math.cos(htheta);
    this.vy += aradius * Math.sin(theta) + hf * Math.sin(htheta);

    this.vx *= drag;
    this.vy *= drag;

    this.cx += this.vx;
    this.cy += this.vy;

    this.cx = this.cx + (this.vx *= drag) + (this.hx - this.cx) * ease;
    this.cy = this.cy + (this.vy *= drag) + (this.hy - this.cy) * ease;
  };

  var draw = function () {
    if (!isPlaying) {
      return;
    }

    let a = 0,
      b = 0,
      p = 0;
    b = (a = ctx.createImageData(cw, ch)).data;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (var i = 0; i < particles.length; i++) {
      particles[i].update();
    }

    for (let i = 0; i < particles.length; i++) {
      p = particles[i];
      const n = (~~p.cx + ~~p.cy * cw) * 4;
      b[n] = 10;
      b[n + 1] = 30;
      b[n + 2] = 76;
      b[n + 3] = 255;
    }

    ctx.putImageData(a, 0, 0);
  };

  const init = async () => {
    calculateSizes();
    ctx.imageSmoothingEnabled = false;
    containerBounds = container.getBoundingClientRect();
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    isPlaying = false;
    particles = [];

    const [image] = await Promise.all([imagePromise]);
    ctx.drawImage(
      image,
      cw / 2 - (image.width * pixelRatio) / 2,
      96 * pixelRatio,
      image.width * pixelRatio,
      image.height * pixelRatio
    );

    pixels = ctx.getImageData(0, 0, cw, ch).data;

    for (var i = 0; i < ch; i = i + density) {
      for (var j = 0; j < cw; j = j + density) {
        var index = (j + i * cw) * 4;

        if (pixels[index + 3] > 108) {
          if (index >= particles.length) {
            particles.push(new Particle(j, i));
          } else {
            particles[index].hx = j;
            particles[index].hy = i;
          }
        }
      }
    }

    isPlaying = true;
  };

  const onMouseMoveHandler = (e) => {
    mx = e.clientX * pixelRatio;
    my = e.clientY * pixelRatio;
  };

  const onMouseLeaveHandler = () => {
    mx = 0;
    my = 0;
  };

  const onResizeHandler = () => {
    if (!isPlaying) {
      return;
    }

    calculateSizes();
    init();
  };

  const onScrollHandler = () => {
    if (!isPlaying) {
      return;
    }

    calculateSizes();
  };

  return {
    async start() {
      await init();
      window.addEventListener('resize', onResizeHandler);
      window.addEventListener('scroll', onScrollHandler);
      container.addEventListener('mousemove', onMouseMoveHandler);
      container.addEventListener('mouseleave', onMouseLeaveHandler);
      animation.addHandler(draw);
    },
    pause() {
      isPlaying = false;
      window.removeEventListener('resize', onResizeHandler);
      window.removeEventListener('scroll', onScrollHandler);
      container.removeEventListener('mousemove', onMouseMoveHandler);
      container.removeEventListener('mouseleave', onMouseLeaveHandler);
      animation.removeHandler(draw);
    },
  };
};
export const useThanosAnimation = ({ canvasRef, containerRef, onError }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    const animation = animate({ canvasRef, containerRef });

    const start = async () => {
      try {
        await animation.start();
      } catch (error) {
        console.log(error);
        setError(error);
        onError(error);
      }
    };

    start();

    return () => {
      animation.pause();
    };
  }, [onError]);

  return { error };
};
